export default {
  state: {
    devices: [],
  },
  getters: {
    devices: (state: any) => {
      return state.devices;
    },
  },
  mutations: {
    updateDevices: (state: any, value: any) => {
      state.devices = value || [];
    },
  },
};
